import { render, staticRenderFns } from "./compact.vue?vue&type=template&id=21e58454&scoped=true&"
import script from "./compact.vue?vue&type=script&lang=js&"
export * from "./compact.vue?vue&type=script&lang=js&"
import style0 from "./compact.vue?vue&type=style&index=0&id=21e58454&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e58454",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wd\\fin24\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21e58454')) {
      api.createRecord('21e58454', component.options)
    } else {
      api.reload('21e58454', component.options)
    }
    module.hot.accept("./compact.vue?vue&type=template&id=21e58454&scoped=true&", function () {
      api.rerender('21e58454', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/compact.vue"
export default component.exports